import * as React from 'react';

import BannerGhost from '@/components/modular-grid/Banner/BannerGhost';
import GameBannerGhost from '@/components/modular-grid/GameBanner/GameBannerGhost';
import GameDualGhost from '@/components/modular-grid/GameDual/GameDualGhost';
import GridGhost from '@/components/modular-grid/Grid/GridGhost';
import WidgetGridGhost from '@/components/modular-grid/WidgetGrid/WidgetGridGhost';
import SectionHeaderGhost from '@/components/SectionHeader/SectionHeaderGhost';
import { CategoriesWithContentTypes } from '@/types/category/categoryTypes';

import styles from './Category.module.scss';

interface GhostCategoryPropTypes {
  category?: CategoriesWithContentTypes;
}

const shouldRenderHeader = (component_type: string, type = '') => {
  if (component_type === 'banner') return false;
  if (
    [
      'Jackpot Banner',
      'Jackpot Hero',
      'Game Shuffle Hero',
      'Widget Banner',
      'Widget Hero',
    ].includes(type)
  )
    return false;

  return true;
};

const GhostCategory: React.FC<GhostCategoryPropTypes> = ({ category }) => {
  if (!category) return null;
  const { component_type = '', type } = category;

  const componentToRender = () => {
    if (component_type === 'banner') return <BannerGhost />;

    switch (type) {
      case 'Game Dual':
        return <GameDualGhost />;
      case 'Game Banner':
        return <GameBannerGhost />;
      case 'Jackpot Banner':
      case 'Jackpot Hero':
      case 'Game Shuffle Hero':
      case 'Widget Banner':
      case 'Widget Hero':
        return <WidgetGridGhost />;
      case 'Extended Single Block':
        return <GridGhost extended={true} />;

      case 'Grid':
      default:
        return <GridGhost />;
    }
  };

  return (
    <div className={styles.wrapper} data-testid="category-ghost-item">
      {shouldRenderHeader(component_type, type) && <SectionHeaderGhost />}
      <div className={styles.ghostCarouselWrapper}>{componentToRender()}</div>
    </div>
  );
};

export default GhostCategory;
